// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Work Sans', 'Work Sans Fallback'"},"className":"__className_c2f31a"};